// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separator[data-v-77c994b2]{width:100%;border-top:1px solid var(--border)}", ""]);
// Exports
module.exports = exports;
